import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { Observable } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { CompanyMortgage } from '../model/company-mortgage';
import { CreditInstitute } from '../../common/model/credit-institute';
import { AutoCompleteSelectionItem, IAutoCompleteService } from '../../core/component/autocomplete-remote/autocomplete-remote.component';
import { PagedFilter } from '../../core/model/paged-filter';
import { CreditInstituteFilter } from '../../common/model/credit-institute-filter';

@Injectable()
export class CreditInstituteService extends DataService<CreditInstitute> implements IAutoCompleteService {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, CreditInstitute, progressBar, 'credit-institute');
  }
  getSelectionItem(id: string, state: { selectedItem: AutoCompleteSelectionItem; options: any }): Observable<AutoCompleteSelectionItem> {
    return this.client.get<CreditInstitute>(`${this.endpoint}/selectionItem/${id}`).pipe(
      map(data => this.createAutoCompleteSelectionItem(data)),
      catchError(e => {
        this.notification.showError(e);
        return [];
      })
    );
  }

  getFilterDefinition(): Observable<PagedFilter<CreditInstituteFilter>> {
    return this.client.get<PagedFilter<CreditInstituteFilter>>(`${this.endpoint}/filter`).pipe(
      map(res => {
        let result = res;
        if (!result.filter.selectedFields || result.filter.selectedFields.length === 0) {
          result.filter.selectedFields = ['name', 'organizationNumber'];
        }

        return result;
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  createAutoCompleteSelectionItem(data: CreditInstitute): any {
    return data
      ? new AutoCompleteSelectionItem(data.name, data.id, Object.assign(new CreditInstitute(), data), data.name)
      : new AutoCompleteSelectionItem('', null, null);
  }

  getSelection(filter: string, options: any, page?: number): Observable<AutoCompleteSelectionItem[]> {
    let queryArgs = {
      filter: filter,
      maxItems: 20,
    };
    if (options) queryArgs['options'] = options;
    if (page && page > 0) queryArgs['page'] = page;

    return this.client.post<CreditInstitute[]>(`${this.endpoint}/selection`, queryArgs).pipe(
      map(data => data.map(item => this.createAutoCompleteSelectionItem(item))),
      catchError(e => {
        this.notification.showError(e);
        return [];
      })
    );
  }
}
